import React, { useState, useContext } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { useFormik } from 'formik';
import * as Yup from 'yup';

import useIsComDomain from "@src/hooks/useIsComDomain";

import BasicModal from "@src/componentsNew/Modals/BasicModal/BasicModal"; // Todo: remove after com
import DesktopLoginPage from "./DesktopLoginPage";
import MobileLoginPage from "./MobileLoginPage";

import {
  DeviceContext,
  deviceType,
  CredentialContext,
  credentialType
} from '@providers';
import { EMAIL_REGEX } from "@src/utils/constants";
import { baseUrl } from "@src/app/routes";

const LoginPage = () => {
  const history = useHistory();
  const isComDomain = useIsComDomain();
  const { isMobile } = useContext<deviceType>(DeviceContext);
  const { currentUser, anonymousCart, mgsAnonymousCart, logIn, loading } = useContext<credentialType>(CredentialContext);

  const [showPassword, setShowPassword] = useState(false);

  // Todo: remove after com
  const [showAlertModal, setShowAlertModal] = useState(false);
  const handleAlertModalClose = (e) => {
    e.stopPropagation();
    setShowAlertModal(false);
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('Enter Email')
      .matches(EMAIL_REGEX, 'Invalid email format'),
    password: Yup.string().required('Enter Password')
  });

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: validationSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      formik.validateForm().then(errors => {
        if (Object.keys(errors).length === 0) {
          // TODO : remove after com complete
          if (isComDomain) {
            setShowAlertModal(true);
            return;
          } else {
            logIn({
              email: values.email,
              password: values.password
            });
          }
        }
      });
    },
  });

  const toggleShowPassword = () => {
    setShowPassword(prev => !prev);
  };

  //@ts-ignore
  const { from } = history.location.state || { from: { pathname: baseUrl } };

  if (currentUser?.token && !anonymousCart && !mgsAnonymousCart) {
    return <Redirect to={from} />
  }

  return (
    <>
      {
        isMobile ?
          <MobileLoginPage
            formik={formik}
            loading={loading}
            showPassword={showPassword}
            onChagneShowPassword={toggleShowPassword}
          />
          :
          <DesktopLoginPage
            formik={formik}
            loading={loading}
            showPassword={showPassword}
            onChagneShowPassword={toggleShowPassword}
          />
      }

      {/* TODO : remove after com complete */}
      {
        (isComDomain && showAlertModal) &&
        <BasicModal
          title='Log-in Not Available'
          titleColor={"#212121"}
          content={`Sorry for the inconvenience caused.
            Service is not available currently.
            Thanks for your patience.`}
          contentColor={"#11141D99"}
          open={showAlertModal}
          onClose={handleAlertModalClose}
          closeButtonText="Got it"
          showCloseIcon={false}
        />
      }
    </>
  )
};

export default LoginPage;
